import { isProduction } from '~/constants/utils';

export const dataTestId = (testid: string): { 'data-testid'?: string } => {
  if (isProduction) {
    return {};
  }

  return { 'data-testid': testid };
};
